import '~/features/ShopLoginButton/init';
import '~/features/initShopToastManager/renderToast';

import {defineInitFunction} from '~/utils/defineInitFunction';

import {initCustomerAccounts} from './initCustomerAccounts';

(() => defineInitFunction('initCustomerAccounts', initCustomerAccounts))();
